module.exports = __webpack_public_path__ + "img/Text_Score_Cards.a51c5275.png";